import { Outlet, useLocation } from "react-router-dom";
import { AccountRouteGuard } from "@/components/account/AccountRouteGuard";

/**
 * Layout "espace client" (`/connexion`, `/compte/**`) — coquille volontairement
 * minimale (pas de `<html>`/`<body>`/chrome propre : nichée comme route
 * enfant de `ShopLayout`, cf. router.tsx, elle hérite donc déjà du
 * header/footer/tab bar boutique — même comportement qu'aujourd'hui côté
 * apps/web, où `(account)` n'a pas de `layout.tsx` propre).
 *
 * Garde d'accès (atelier "compte") : `AccountRouteGuard` (cf. son propre
 * commentaire) centralisée ICI plutôt que répétée par route dans
 * `router.tsx` — contrairement au motif admin (`AdminRouteGuard` posé
 * individuellement autour de chaque élément de route dans `router.tsx`), ce
 * layout est le seul endroit qui connaît à la fois `/connexion` ET
 * `/compte/**` : il peut donc discriminer par chemin courant pour n'appliquer
 * la garde qu'aux routes `/compte/**`, jamais à `/connexion` elle-même (qui
 * doit rester accessible sans session, sous peine de boucle de redirection).
 */
export function AccountLayout() {
  const location = useLocation();
  const isConnexionRoute = location.pathname === "/connexion";

  if (isConnexionRoute) {
    return <Outlet />;
  }

  return (
    <AccountRouteGuard>
      <Outlet />
    </AccountRouteGuard>
  );
}
